<template>
  <div
    ref="popoverRef"
    v-clickoutside="hidePopover"
    class="lp-dropdown"
    data-ua-unique-id="unique-dropdown"
    v-on="listenersGlobal"
  >
    <div ref="trigger" class="lp-dropdown-trigger" v-on="listenersTrigger">
      <slot />
    </div>
    <teleport to="body">
      <transition :name="transition">
        <div
          v-show="show"
          ref="popover"
          class="lp-dropdown-slot"
          :class="[placement && `lp-dropdown-slot-${placementSide}`]"
          @toggle-dropdown.stop="toggleDropdown"
        >
          <slot name="menu" />
        </div>
      </transition>
    </teleport>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref, provide } from 'vue'
import { Positions } from '@/models/enums'
import { usePopover } from '@/hooks'
import { clickOutside } from '@/directives'

export default defineComponent({
  name: 'lp-dropdown',
  directives: {
    clickoutside: clickOutside,
  },
  props: {
    placement: {
      default: Positions.BL,
      type: String,
      validator: (value: Positions) =>
        [
          Positions.B,
          Positions.BL,
          Positions.BR,
          Positions.L,
          Positions.LT,
          Positions.LB,
          Positions.R,
          Positions.RT,
          Positions.RB,
          Positions.T,
          Positions.TL,
          Positions.TR,
        ].includes(value),
    },
    clickable: Boolean,
    permanent: Boolean,
    disabled: Boolean,
    // autoposition: { type: Boolean, default: true },
  },
  setup(props) {
    const popover = ref(null)
    const trigger = ref(null)
    const {
      show,
      placement,
      permanent,
      disabled,
      handleMouseEnter,
      handleMouseLeave,
      hidePopover,
      showPopover,
    } = usePopover({
      ...props,
      popover,
      trigger,
      arrowCalculation: false,
      disableSetPosition: false,
      isDropdown: true,
      allowedMouseOverTransitionElements: [
        '.lp-dropdown',
        '.lp-tooltip-popper',
      ],
    })

    provide('show', show)

    function toggleDropdown(e: MouseEvent, force = false) {
      if (disabled.value) {
        return
      }

      if (show.value) {
        hidePopover(e, force)
      } else {
        showPopover()
      }
    }

    provide('toggleDropdown', toggleDropdown)

    const transition = computed(() => `drop-${placement.value}`)
    const placementSide = computed(() => placement.value?.split('-')[0])
    const listenersGlobal = computed(() => {
      return props.clickable
        ? props.permanent
          ? {}
          : { click: toggleDropdown }
        : {
            mouseenter: handleMouseEnter,
            mouseleave: handleMouseLeave,
          }
    })
    const listenersTrigger = computed(() => {
      return props.permanent
        ? {
            click: toggleDropdown,
          }
        : {}
    })
    provide('listenersGlobal', listenersGlobal)

    return {
      toggleDropdown,
      transition,
      placementSide,
      listenersGlobal,
      listenersTrigger,
      show,
      hidePopover,
      placement,
      popover,
      trigger,
      showPopover,
      handleMouseEnter,
      handleMouseLeave,
    }
  },
})
</script>
